import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GenericForm from '../components/GenericForm';
import { add_donor } from '../api/donor_api';
import { isValidIsraeliID, isOnlyNumbers, isValidPhoneNumber, isValidEmail, isValidPassport } from '../utils/validationId';

const AddDonor = () => {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);


    const handleSubmit = async (data) => {
        if (isSubmitting) return;
        const rawId = data.donor_id || data.id;
        const idToCheck = rawId?.toString().trim();
        const idValue = data.donor_id || data.id || data.donorId;
        const type = data.id_type;

        if (type === 'tz') {
            if (!idValue || !isOnlyNumbers(idValue) || !isValidIsraeliID(idValue)) {
                alert("מספר ת.ז. לא תקין");
                return;
            }
        } else if (type === 'passport') {
            if (!idValue || !isValidPassport(idValue)) {
                alert("מספר דרכון לא תקין");
                return;
            }
        }


      
        data.donor_id = idToCheck;

        // ולידציה של טלפון ואימייל
        if (data.phone && !isValidPhoneNumber(data.phone)) {
            alert("מספר פלאפון לא תקין");
            return;
        }
        if (data.email && !isValidEmail(data.email)) {
            alert("אימייל לא תקין");
            return;
        }

        setIsSubmitting(true);
        try {
            await add_donor(data);
            alert('תורם נוסף בהצלחה!');
            navigate('/donors');
        } catch (err) {
            console.error("Add donor error:", err);
            // בדיקה אם השגיאה היא אכן כפילות (409) או שגיאת שרת אחרת
            if (err.response?.status === 409 || err.status === 409) {
                if (type === 'passport') {
                    alert('מספר דרכון כבר קיים במערכת');
                } else {
                    alert('מספר ת.ז. כבר קיים במערכת');
                }
            } else {
                alert('הוספת תורם נכשלה: ' + (err.response?.data?.message || 'שגיאת שרת'));
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className="top-buttons-container">
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
            <h2 style={{ color: "#150F6B", textAlign: "center" }}>הוספת תורם</h2>
            <div style={{ opacity: isSubmitting ? 0.5 : 1, pointerEvents: isSubmitting ? 'none' : 'auto' }}>
                <GenericForm kind="donor" mode="add" onSubmit={handleSubmit} />
            </div>
        </>
    );
};

export default AddDonor;